import IconAvatar from './IconAvatar';

export default IconAvatar;
